module.exports = __webpack_public_path__ + "static/media/CheckboxUnchecked.67618d58.svg";